import { z } from 'zod';

export interface UserAppSettingsDto {
  id: number;
  userId: string;
  logoThemeId: number | null;
  accentThemeId: number | null;
  showAnimations: boolean;
}

export const CreateUserAppSettingsSchema = z
  .object({
    userId: z.string().uuid(),
    logoThemeId: z.number().int().positive().nullable().optional(),
    accentThemeId: z.number().int().positive().nullable().optional(),
    showAnimations: z.boolean().optional(),
  })
  .strict();

export const UpdateUserAppSettingsSchema = z
  .object({
    logoThemeId: z.number().int().positive().nullable().optional(),
    accentThemeId: z.number().int().positive().nullable().optional(),
    showAnimations: z.boolean().optional(),
  })
  .strict();

export type CreateUserAppSettingsRequest = z.infer<
  typeof CreateUserAppSettingsSchema
>;
export type UpdateUserAppSettingsRequest = z.infer<
  typeof UpdateUserAppSettingsSchema
>;
